import BrandChat from './BrandChat'

export default BrandChat
